import { Component } from '@angular/core';
import { Router } from '@angular/router';
import * as Constants from '@emi/shared/constants';
@Component({
    selector: 'via-get-started',
    templateUrl: './get-started.component.html',
    styleUrls: ['./get-started.component.scss'],
})
export class GetStartedComponent {
    constructor(private router: Router) {}
    public navigateToDefinitions(): void {
        this.router.navigate([Constants.Routes.DEFINITIONS]);
    }
}